import React, { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { numberActions } from "../../../redux/actions/guides";
import { SimpleModal, MyInput, ComboBox, DialogModal } from "../../../components";
import * as Yup from "yup";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import { useStateIfMounted } from "use-state-if-mounted";

const options = [
  { id: "Оприходование", title: "Оприходование" },
  { id: "Списание", title: "Списание" },
  { id: "Перемещение", title: "Перемещение" },
  { id: "Заказ поставщику", title: "Заказ поставщику" },
  { id: "Приемка", title: "Приемка" },
  { id: "Заказ клиента", title: "Заказ клиента" },
  { id: "Отгрузка", title: "Отгрузка" },
  { id: "Заявка на производство", title: "Заявка на производство" },
  { id: "Спецификация", title: "Спецификация" },
  { id: "Комплектация", title: "Комплектация" },
  { id: "Инвентаризация", title: "Инвентаризация" },
];

export const getType = (type) => {
  switch (type) {
    case "Оприходование":
      return "0";
    case "Списание":
      return "1";
    case "Перемещение":
      return "2";
    case "Заказ поставщику":
      return 3;
    case "Приемка":
      return 4;
    case "Отгрузка":
      return 5;
    case "Заказ клиента":
      return 6;
    case "Производство":
      return 8;
    case "Спецификация":
      return 9;
    case "Комплектация":
      return 10;
    case "Инвентаризация":
      return 11;
    case "Платеж":
      return 12;
    default:
      return null;
  }
};

const defaultValues = {
  startNumber: "",
  countNumber: "",
  prefix: "",
  documentType: { id: "Оприходование", title: "Оприходование" },
};

const validationSchema = Yup.object().shape({
  startNumber: Yup.string().required("Укажите начальный индекс"),
  prefix: Yup.string().required("Укажите префикс").max(20, "Превышено максимальное кол-во символов(20)"),
  documentType: Yup.object().required("Укажите тип документа").nullable(),
});

export const ModalNumber = ({ modalShow, onClose, isAddMode, setIsAddMode, id, refresh = () => { } }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted, error } = useSelector((state) => state.guides.numbers);

  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = (data) => {
    delete data.countNumber;
    data.documentType = getType(data.documentType.id);

    return isAddMode ? dispatch(numberActions.create(data)) : dispatch(numberActions.update(item.id, data));
  };

  useEffect(() => {
    if (!modalShow || isAddMode) return;

    dispatch(numberActions.getById(id));

    return () => dispatch({ type: "RESET_ITEM_NUMBERS" });
  }, [modalShow]);

  useEffect(() => {
    if (!fetchedItem || isAddMode) return;

    Object.keys(defaultValues).forEach((field) => setValue(field, item[field]));
    setValue(
      "documentType",
      item.documentType
        ? { id: item.documentType, title: item.documentType }
        : { id: "Оприходование", title: "Оприходование" }
    );
  }, [item]);

  const handleDeleteClick = useCallback((id) => {
    dispatch(numberActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  // Effect for handling successful deletion
  useEffect(() => {
    if (deleted) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
      console.log('Автонумерация документов успешно удалена');
    }
  }, [deleted]);

  useEffect(() => {
    if (!error && isAddMode && fetchedItem) {
      setIsAddMode(false);
    }
  }, [error, loadingItem, fetchedItem]);

  const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новая автонумерация документов" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="sm"
        fullScreen={false}
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          closeModalFunc();
        }}
      >
        <form noValidate>
          <ComboBox
            control={control}
            name="documentType"
            options={options}
            required
            errors={errors?.documentType}
            label="Тип документа"
            loading={false}
            disableClearable
          />
          <MyInput name="prefix" control={control} label="Префикс документа" required errors={errors?.prefix} />
          <MyInput name="startNumber" control={control} label="Начальный номер" required errors={errors?.startNumber} />
          {!isAddMode && <MyInput name="countNumber" control={control} label="Следующий номер для документа" required disabled />}
          <div>
            <Button
              disabled={item?.id === null || item?.id === undefined}
              aria-describedby={id}
              size="small"
              color="primary"
              onClick={() => setDeleteDialog(true)}
              startIcon={<DeleteIcon />}
            >
              Удалить
            </Button>
          </div>
        </form>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить автонумерацию для документа - ${item?.documentType}? Это действие невозможно отменить.`}
      />
    </div>
  );
};